import { COURSE_INFO } from '@components/locale-pages/home/courses'
import ResponsiveCourseCard from './responsive-course-card'

type Props = {
  courseCodes: string[]
  description?: JSX.Element
  title?: string
}

const RecommendedCourses = ({ courseCodes, description, title }: Props) => {
  return (
    <div className="my-12 lg:mb-16 flex flex-col text-grey container mx-auto lg:px-3 py-5 lg:bg-blue-50 lg:bg-opacity-25">
      <h2 className="text-2xl md:text-2xl font-600 mb-4 leading-tight">
        {title ?? 'More recommended courses for you'}
      </h2>
      {courseCodes.length !== 0 && (
        <div className="flex flex-wrap justify-around gap-4">
          {courseCodes.map((code, index) => (
            <ResponsiveCourseCard key={index} course={COURSE_INFO[code]} />
          ))}
        </div>
      )}
      {description && <p>{description}</p>}
    </div>
  )
}

export default RecommendedCourses
